import parsePhoneNumber from 'libphonenumber-js/max';
import utils from './livr-utils';
import {ERROR_CODES, MIN_PHONE_NUMBER_LENGTH_TO_PARSE} from '../../modules/DNFORM/DNFORM-utils/DNFORM-constants';

// According to the LIVR's naming convention the function names are written in snake_case
// eslint-disable-next-line camelcase
export function list_length(param1, param2) {
	let minLen;
	let maxLen;

	if (arguments.length <= 1) {
		console.error('LIVR: undefined list_length', {param1, param2});
	} else if (arguments.length === 2) {
		// In this case the param2 is an object, that's why we use the param1 for both
		minLen = param1;
		maxLen = param1;
	} else if (arguments.length > 2) {
		minLen = param1;
		maxLen = param2;
	}

	return list => {
		if (utils.isNoValue(list)) return '';
		if (!Array.isArray(list)) return ERROR_CODES.FORMAT_ERROR;
		if (list.length < minLen) return ERROR_CODES.TOO_FEW_ITEMS;
		if (list.length > maxLen) return ERROR_CODES.TOO_MANY_ITEMS;
		else return '';
	};
}
// eslint-disable-next-line camelcase
export function min_date(minDate) {
	if (arguments.length <= 1) {
		console.error('LIVR: undefined min_date');
	}

	return inputDate => {
		if (utils.isNoValue(inputDate)) return '';
		if (!utils.isValidDate(inputDate)) return ERROR_CODES.INVALID_DATE;
		if (inputDate < minDate) return ERROR_CODES.DATE_LESS_THAN_MIN;
		else return '';
	};
}
// eslint-disable-next-line camelcase
export function max_date(maxDate) {
	if (arguments.length <= 1) {
		console.error('LIVR: undefined max_date');
	}

	return inputDate => {
		if (utils.isNoValue(inputDate)) return '';
		if (!utils.isValidDate(inputDate)) return ERROR_CODES.INVALID_DATE;
		if (inputDate > maxDate) return ERROR_CODES.DATE_GREATER_THAN_MAX;
		else return '';
	};
}
// eslint-disable-next-line camelcase
export function max_file_size(maxSizeInMB) {
	if (arguments.length <= 1) {
		console.error('LIVR: undefined max_file_size');
	}

	const maxSizeInBytes = utils.convertMegaByteToByte(maxSizeInMB);

	return files => {
		const isLargerThanAllowed = Array.from(files).some((file) => file.size > maxSizeInBytes);
		if (isLargerThanAllowed) return ERROR_CODES.MAX_FILE_SIZE;
		else return '';
	};
}
// eslint-disable-next-line camelcase
export function max_total_file_size(maxTotalSizeInMB) {
	if (arguments.length <= 1) {
		console.error('LIVR: undefined max_total_file_size');
	}

	const maxTotalSizeInBytes = utils.convertMegaByteToByte(maxTotalSizeInMB);

	return files => {
		const totalFileSizeInBytes = Array.from(files).reduce((acc, curr) => {
			return acc + curr.size;
		}, 0);

		if (totalFileSizeInBytes > maxTotalSizeInBytes) return ERROR_CODES.MAX_TOTAL_FILE_SIZE;
		else return '';
	};
}
// eslint-disable-next-line camelcase
export function max_file_count(maxFileCount) {
	if (arguments.length <= 1) {
		console.error('LIVR: undefined max_file_count');
	}

	return files => {
		if (files.length > maxFileCount) return ERROR_CODES.MAX_FILE_COUNT;
		else return '';
	};
}
// eslint-disable-next-line camelcase
export function allowed_file_extensions() {
	if (arguments.length <= 1) {
		console.error('LIVR: undefined allowed_file_extensions');
	}

	const allowedFileExtensions = Array.from(arguments).filter((arg) => typeof arg === 'string');

	return files => {
		const hasFileWithForbiddenExtension = utils.hasFileWithForbiddenExtension(allowedFileExtensions, files);
		if (hasFileWithForbiddenExtension) return ERROR_CODES.FORBIDDEN_FILE_EXTENSION;
		return '';
	};
}
// eslint-disable-next-line camelcase
export function allowed_filename_pattern(allowedPattern) {
	if (arguments.length <= 1) {
		console.error('LIVR: undefined allowed_filename_pattern');
	}

	const patternRegex = new RegExp(allowedPattern);

	return files => {
		const isInvalidFilename = Array.from(files).some((file) => !patternRegex.test(file.name));
		if (isInvalidFilename) return ERROR_CODES.FORBIDDEN_FILENAME_PATTERN;
		return '';
	};
}
// eslint-disable-next-line camelcase
export function required_if(controlField, currenStepModel) {
	if (arguments.length > 1 && (!controlField || !currenStepModel)) {
		console.error('LIVR: the control field of the "required_if" rule is missed or incomparable');
	}

	return value => {
		const controlFieldValue = currenStepModel[controlField] || '';
		// Return REQUIRED if the control input has truthy value and the controlled input is empty
		if (controlFieldValue && utils.isEmptyValue(value)) return ERROR_CODES.REQUIRED;
		return '';
	};
}
// redefine default required validation, to handle empty checkbox group and multi-select edge-cases
export function required() {
	return value => {
		if (utils.isEmptyValue(value)) return ERROR_CODES.REQUIRED;
		return '';
	};
}
// eslint-disable-next-line camelcase
export function phone_number() {
	return phoneNumber => {
		const phoneNumberAsString = Object.values(phoneNumber).join('');
		if (!phoneNumberAsString.length) return '';

		const mergedPhoneNumber = phoneNumberAsString.startsWith('+') ? phoneNumberAsString : `+${phoneNumberAsString}`;
		if (phoneNumberAsString.startsWith('+36')) {
			if (mergedPhoneNumber.length < MIN_PHONE_NUMBER_LENGTH_TO_PARSE) {
				return ERROR_CODES.INVALID_PHONE_NUMBER;
			}
		}
		
		const parsedPhoneNumber = parsePhoneNumber(mergedPhoneNumber);
		if (parsedPhoneNumber && !parsedPhoneNumber.isValid()) {
			return ERROR_CODES.INVALID_PHONE_NUMBER;
		}

		return '';
	};
}
// eslint-disable-next-line camelcase
export function allowed_email_domains() {
	if (arguments.length <= 1) {
		console.error('LIVR: undefined allowed_email_domains');
	}

	const allowedDomains = Array.from(arguments).filter((arg) => typeof arg === 'string');
	const regex = new RegExp(`@(?:${allowedDomains.join('|')})$`);

	return email => {
		const isDomainAllowed = regex.test(email);
		if (!isDomainAllowed) return ERROR_CODES.FORBIDDEN_EMAIL_DOMAIN;
		return '';
	};
}



// WEBPACK FOOTER //
// ../source/common/livr/livr-extra-rules.js